import { render, staticRenderFns } from "./TaskBlockCommentParent.vue?vue&type=template&id=7360272b&scoped=true&"
import script from "./TaskBlockCommentParent.vue?vue&type=script&lang=js&"
export * from "./TaskBlockCommentParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7360272b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7360272b')) {
      api.createRecord('7360272b', component.options)
    } else {
      api.reload('7360272b', component.options)
    }
    module.hot.accept("./TaskBlockCommentParent.vue?vue&type=template&id=7360272b&scoped=true&", function () {
      api.rerender('7360272b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Task/TaskBlockCommentParent.vue"
export default component.exports